define(['./VinLookupState', './VehicleEditState', './VehicleInfoState'],
    (vinLookupState, vehicleEditStateOrig, vehicleInfoState) => (VinLookupService, tileModel) => {
        let state = undefined;
        const dto = tileModel.viewModel;
        const vehicleEditState = vehicleEditStateOrig(VinLookupService);

        function toVinLookup(vin) {
            state = {
                'id': 'enterOrEdit',
                'data': vinLookupState(VinLookupService, {
                    initialVin: vin,
                    onVinResult(_vin, make, model, year) {
                        dto.make = make;
                        dto.model = model;
                        dto.year = year;
                        dto.vin = _vin;
                        toSummary(() => toVinLookup(''));
                    },
                    onVinFailure() {
                        dto.make = undefined;
                        dto.model = undefined;
                        dto.year = undefined;
                        dto.vin = undefined;
                        toEditVehicle();
                    }
                })
            };
        }


        function toEditVehicle() {
            state = {
                'id': 'editVehicle',
                'data': vehicleEditState({
                    dto,
                    onSubmit() {
                        toSummary(toEditVehicle);
                    },
                    onCancel() {
                        toVinLookup('');
                    }
                })
            };
        }


        function toSummary(toPrevState) {
            state = {
                'id': 'complete',
                'data': vehicleInfoState({
                    dto,
                    isEditable: () => !tileModel.isLocked,
                    onEdit: toPrevState
                })
            };
        }


        toVinLookup('');
        return {
            get state() {
                return state;
            },
            get isComplete() {
                return state.id === 'complete';
            }
        };
    }
);


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/quickquote/pa/tiles/vehicle/models/VehicleTile.js
 **/